<script lang="ts">
  // 12-point-ish sparkline for condition cards: de-emphasised line, accent end dot,
  // optional target band wash. No axes — the card's number carries the value.
  let { values, color = 'var(--text-3)', band = null, width = 120, height = 34 }: {
    values: number[]; color?: string; band?: { low?: number; high?: number } | null; width?: number; height?: number;
  } = $props();
  const lo = $derived(Math.min(...values, band?.low ?? Infinity));
  const hi = $derived(Math.max(...values, band?.high ?? -Infinity));
  const y = (v: number) => 3 + (1 - (v - lo) / (hi - lo || 1)) * (height - 6);
  const x = (i: number) => 2 + (i / Math.max(1, values.length - 1)) * (width - 8);
  const d = $derived(values.map((v, i) => `${i ? 'L' : 'M'}${x(i).toFixed(1)},${y(v).toFixed(1)}`).join(' '));
</script>

<svg {width} {height} aria-hidden="true">
  {#if band && (band.low != null || band.high != null)}
    {@const top = y(band.high ?? hi)}
    {@const bot = y(band.low ?? lo)}
    <rect x="0" y={Math.min(top, bot)} width={width} height={Math.max(1, Math.abs(bot - top))} fill="var(--ok)" opacity="0.1" />
  {/if}
  <path {d} fill="none" stroke="var(--line-strong)" stroke-width="1.5" stroke-linejoin="round" />
  {#if values.length}<circle cx={x(values.length - 1)} cy={y(values[values.length - 1])} r="3" fill={color} stroke="var(--surface)" stroke-width="1.5" />{/if}
</svg>
